var _path, _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    viewBox: "0 0 96 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.0378C0 5.14673 4.77563 0.371094 10.6667 0.371094H85.3333C91.2244 0.371094 96 5.14672 96 11.0378V85.7044C96 91.5955 91.2244 96.3711 85.3333 96.3711H10.6667C4.77563 96.3711 0 91.5955 0 85.7044V11.0378Z",
    fill: "url(#paint0_linear_1972_80262)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1972_80262",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 64,
    height: 65
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16.3711,
    width: 64,
    height: 64,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1972_80262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.2084 71.9826C30.7195 72.3826 30.1973 72.4048 29.6417 72.0492C29.0861 71.6937 28.9195 71.2048 29.1417 70.5826L34.1417 54.2492L21.1417 44.9159C20.6084 44.5603 20.4417 44.0714 20.6417 43.4492C20.8417 42.827 21.2528 42.5159 21.875 42.5159H38.0084L43.1417 25.4492C43.2306 25.0937 43.3973 24.8492 43.6417 24.7159C43.8861 24.5826 44.1417 24.5159 44.4084 24.5159C44.675 24.5159 44.9306 24.5826 45.175 24.7159C45.4195 24.8492 45.5861 25.0937 45.675 25.4492L50.8084 42.5159H66.9417C67.5639 42.5159 67.975 42.827 68.175 43.4492C68.375 44.0714 68.2084 44.5603 67.675 44.9159L54.675 54.2492L59.675 70.5826C59.8973 71.2048 59.7306 71.6937 59.175 72.0492C58.6195 72.4048 58.0973 72.3826 57.6084 71.9826L44.4084 61.9826L31.2084 71.9826ZM38.0084 60.2492L44.4084 55.3159L50.8084 60.2492L48.4084 52.1159L54.4084 47.8492H46.9417L44.4084 39.5826L41.875 47.8492H34.4084L40.4084 52.1159L38.0084 60.2492ZM68.675 71.9826L64.7417 68.9826L60.8084 56.3826L69.075 50.5159H74.075C74.6973 50.5159 75.1195 50.827 75.3417 51.4492C75.5639 52.0714 75.4084 52.5603 74.875 52.9159L67.075 58.5159L70.8084 70.5159C71.0306 71.1381 70.8528 71.6381 70.275 72.0159C69.6973 72.3937 69.1639 72.3826 68.675 71.9826ZM54.8084 37.1826L52.8084 30.3826L54.275 25.4492C54.3639 25.0937 54.5306 24.8381 54.775 24.6826C55.0195 24.527 55.275 24.4492 55.5417 24.4492C55.8084 24.4492 56.0639 24.5381 56.3084 24.7159C56.5528 24.8937 56.7195 25.1381 56.8084 25.4492L60.4084 37.1826H54.8084Z",
    fill: "url(#paint1_linear_1972_80262)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1972_80262",
    x1: 0,
    y1: 96.3711,
    x2: 113.373,
    y2: 66.6559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFE3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9DFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1972_80262",
    x1: 20.5599,
    y1: 72.3002,
    x2: 84.0837,
    y2: 53.2049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.18e9e367f67d4bdc7afa85f1ff087639.svg";
export { ForwardRef as ReactComponent };